import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, } from 'react';
import { Box, styled, } from '@mui/material';
import SelectInput from '../../atoms/SelectInput';
import { Text } from '../../atoms/typography';
import { Modal, } from '../Modal';
const SelectWithTopMargin = styled(SelectInput) `
  margin-top: 24px;
`;
const SelectPartnerModal = ({ isLoading = false, isOpen, onClose, onSave, partnersData, selectedPartner, }) => {
    const [partner, setPartner] = useState(selectedPartner);
    const [partnerError, setPartnerError] = useState(false);
    const [partners, setPartners] = useState([]);
    useEffect(() => {
        const updatedPartners = partnersData.map(({ label, value }) => ({ label, value }));
        setPartners(updatedPartners);
    }, [partnersData]);
    const handlePartnerChange = (event) => {
        setPartnerError(false);
        setPartner(event.target.value);
    };
    const content = (_jsxs(Box, { children: [_jsx(Text, { children: "Select a partner. You can change your settings later in the sidebar." }), _jsx(SelectWithTopMargin, { fullWidth: true, hasError: partnerError, initialValue: partner, isRequired: true, label: 'Select a partner', onChange: handlePartnerChange, options: partners })] }));
    const handleOnClick = () => {
        if (!partner) {
            setPartnerError(true);
            return;
        }
        setPartnerError(false);
        onSave(partner);
        onClose();
    };
    const actions = [
        {
            label: 'Save',
            onClick: handleOnClick,
            color: 'primary',
            variant: 'contained'
        },
    ];
    return _jsx(Modal, { actions: actions, content: content, isLoading: isLoading, isOpen: isOpen, onClose: onClose, title: 'Set Partner' });
};
export default SelectPartnerModal;
//# sourceMappingURL=index.js.map